import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function FooterSection() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-flex items-center gap-2 mb-4 cursor-pointer">
              <span className="font-heading text-xl font-bold text-background-50 tracking-tight">
                VigorBuy
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              Your trusted resource for the VigorBuy Spreadsheet — comprehensive buying guides, verified products, and safety tips updated daily.
            </p>
          </div>

          {/* Spreadsheet Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">Spreadsheet</h4>
            <ul className="space-y-2.5">
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                  Main Spreadsheet
                </a>
              </li>
              <li>
                <Link to="/guide/vigorbuy-spreadsheet-complete-guide" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                  Beginner's Guide
                </Link>
              </li>
              <li>
                <Link to="/#categories" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                  All Categories
                </Link>
              </li>
              <li>
                <Link to="/#safety" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
                  Safety Tips
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Categories */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">Top Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* More */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">Resources</h4>
            <ul className="space-y-2.5">
              {categories.slice(5, 10).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} VigorBuy. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">
              Home
            </Link>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">
              Main Site
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}